import { useState } from "react";
import type { JobDto, StockLocationDto } from "@grizzly/shared";
import { api, ApiClientError } from "../../lib/apiClient.js";
import { Button } from "../ui/button.js";
import { SelectInput, TextInput } from "../ui/field.js";
import { useToast } from "../../lib/useToast.js";
import { useI18n } from "../../i18n/index.js";

export function IssueStockForm({
  materialId,
  locations,
  jobs,
  onIssued,
}: {
  materialId: string;
  locations: StockLocationDto[];
  jobs: JobDto[];
  onIssued(): void;
}) {
  const { push } = useToast();
  const { t } = useI18n();
  const [jobId, setJobId] = useState("");
  const [locationId, setLocationId] = useState(locations[0]?.id ?? "");
  const [quantity, setQuantity] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      await api.issueStock({ jobId, materialId, locationId, quantity });
      push(t("inventory.materialIssued"));
      setQuantity("");
      onIssued();
    } catch (err) {
      if (err instanceof ApiClientError) push(err.message, undefined, "danger");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-2 rounded border border-line p-3">
      <SelectInput
        label={t("inventory.job")}
        options={jobs.map((j) => ({ value: j.id, label: `${j.number} · ${j.title}` }))}
        value={jobId}
        onChange={(e) => setJobId(e.target.value)}
      />
      <div className="grid gap-2 sm:grid-cols-2">
        <SelectInput
          label={t("inventory.location")}
          options={locations.map((l) => ({ value: l.id, label: l.name }))}
          value={locationId}
          onChange={(e) => setLocationId(e.target.value)}
        />
        <TextInput
          label={t("common.fields.quantity")}
          value={quantity}
          onChange={(e) => setQuantity(e.target.value)}
        />
      </div>
      <Button variant="primary" disabled={busy || !jobId || !quantity} onClick={submit}>
        {busy ? t("inventory.issuing") : t("inventory.issueToJob")}
      </Button>
    </div>
  );
}
